<div class="c-gameTier">
  <span class="c-gameTier__text">{{ 'home.lobby.level' | translate | uppercase }}</span>
  <img
    [src]="tierImage"
    class="c-gameTier__img"
    alt="Tier" />
</div>
